import React from "react";
import RadioItem from "./RadioItem";

//  Derived from BauerOptimiser RadioGrouo
//
const RadioGroup = ({
  items,
  value,
  width,
  height,
  unboxed,
  style,
  radioStyle,
  disabled = false,
  onClick,
}) => {
  const groupStyle = {
    boxSizing: "border-box",
    height: 42,
    padding: "12px 16px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  };

  const boxedStyle = {
    ...groupStyle,
    border: "1px solid #D7D7D7",
    borderRadius: 5,
  };

  let usestyle = unboxed ? groupStyle : boxedStyle;
  usestyle = { ...usestyle, ...style};
  if (width) usestyle = { ...usestyle, width: width};
  if (height) usestyle = { ...usestyle, height: height};

  return (
    <div style={usestyle}>
      {items.map((item) => (
        <RadioItem
          key={item.label + item.id}
          label={item.label}
          style={radioStyle}
          disabled={disabled}
          checked={item.id === value}
          onClick={() => onClick(item.id)}
        />
      ))}
    </div>
  );
};
export default RadioGroup;
